/* eslint-disable no-param-reassign */
import { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { getForm } from 'apps/web_forms/api/api';
import { setFieldsWithExpressions, setFieldsToWatch, setDispatchAnswers } from 'apps/web_forms/slices/formSlice';

import { ALWAYS_FETCH_FORM } from 'apps/web_forms/utils/constants';
import { createFieldsWithIndexesForDispatch, createFieldNamesArray, lookAtFieldToWatchFromFormulas } from 'apps/web_forms/utils/arrays'

const useXForm = ({ formId, formVersion, submissionId }) => {
  const [form, setForm] = useState({});
  const [error, setError] = useState({ error: false, code: null });
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const getFormApiCall = async () => {
      try {
        setLoading(true);
        const formResponse = await getForm({ formId, formVersion, submissionId });
        const { inputList, dispatchInputList } = formResponse;
        const fieldNamesArray = createFieldNamesArray(inputList);

        if(dispatchInputList !== undefined){
          const fieldsWithIndexes = createFieldsWithIndexesForDispatch(dispatchInputList);

          const dispatchAnswers = {};
    
          fieldsWithIndexes.forEach((field) => {
            if(field.hasOwnProperty("initialAnswer")){
              dispatchAnswers[field.identifier] = field.initialAnswer;
            }
          });

          dispatch(setDispatchAnswers(dispatchAnswers));
        }
        
        const { fieldsWithExpressions, fieldsToWatch } =
          lookAtFieldToWatchFromFormulas(inputList, fieldNamesArray);

        dispatch(setFieldsWithExpressions(fieldsWithExpressions));
        dispatch(setFieldsToWatch(fieldsToWatch));

        setForm(formResponse);
      } catch (ex) {
        setError({
          error: true,
          code: ex?.response?.status ?? 500
        });
      } finally {
        setLoading(false);
      }
    };

    if (ALWAYS_FETCH_FORM || formVersion) {
      getFormApiCall();
    }
  }, [formVersion]);

  if (!form) {
    return useMemo(() => ({form: null, error, loading}), [error]);
  }

  return useMemo(() => ({ form, error, loading }), [form, error, loading]);
};

export default useXForm;
